module.exports = __webpack_public_path__ + "img/一站式安全服务3.ce73d69c.jpg";